export const StickyNoteBackground = [
  '#f7dc6f',
  '#85c1e9',
  '#aed6f1',
  '#d5f5e3',
  '#fadbd8',
  '#f8c471',
  '#d7bde2',
  '#abebc6'
];